import { KYMW1100Model } from './../kymw1100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * JANコードインストア採番クラス
 *
 * @export GetJANCodeService
 * @class GetJANCodeService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetJANCodeService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW1100Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetJANCodeService
   */
  private getBody(): PlessRequest {
    return new PlessRequest(null);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetJANCodeService
   */
  execute(model: KYMW1100Model, successFunc: Function = null): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getJANCode', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetJANCodeService
   */
  success(data: any): void {
    this.model.janCode = '';
    this.model.setJANCode(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
